import { render, staticRenderFns } from "./detailRow.vue?vue&type=template&id=6aeb2f16&"
import script from "./detailRow.vue?vue&type=script&lang=js&"
export * from "./detailRow.vue?vue&type=script&lang=js&"
import style0 from "./detailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports